import * as React from "react"
import { createFileRoute } from "@tanstack/react-router"

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from "@/components/ui/credenza"
import MeterSizeRateForm from "@/components/forms/meter-size-rate-form"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/meter-size-rates/add",
)()

export function AddMeterSizeRates() {
  const [showModal, setShowModal] = React.useState<boolean>(false)

  return (
    <main>
      <div>
        <Button
          onClick={() => {
            if (!validateUserAddPermission()) return
            setShowModal((prev) => !prev)
          }}
        >
          <Icons.add className="size-4" />
          Add Meter Size Rates
        </Button>
      </div>
      <Credenza open={showModal} onOpenChange={setShowModal}>
        <CredenzaContent className="w-full md:min-w-[800px]">
          <CredenzaBody>
            <MeterSizeRateForm
              onClose={() => setShowModal(false)}
              setShowModal={setShowModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
